import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ChevronUpOutline = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("g", {
    "data-name": "Layer 2",
    key: "k0"
  }, React.createElement("path", {
    d: "M16 14.5a1 1 0 01-.71-.29L12 10.9l-3.3 3.18a1 1 0 01-1.41 0 1 1 0 010-1.42l4-3.86a1 1 0 011.4 0l4 4a1 1 0 010 1.42 1 1 0 01-.69.28z",
    "data-name": "chevron-up"
  })));
});
ChevronUpOutline.displayName = 'ChevronUpOutline';
export var ChevronUpOutlineDimensions = {
  height: 20,
  width: 20
};